/* @flow */
// @jsx h
import Toasty from './Toasty'

export default {
  install(Vue: any, options: any) {
    const ToastyComponent = Vue.extend(Toasty)
    Vue.component('toasty', ToastyComponent)

    // Create container element, mount & register globally.
    const toastyContainer = document.createElement('section')
    if (toastyContainer) toastyContainer.id = 'toasty'
    const body = document.querySelector('body')
    if (body) body.appendChild(toastyContainer)

    /* eslint-disable no-new */
    const toastyComponent = new ToastyComponent()
    toastyComponent.$mount('#toasty')
    Vue.$toast = toastyComponent.add
    Vue.$removeToast = toastyComponent.remove
    Vue.$removeAllToasts = toastyComponent.removeAll
    Vue.prototype.$toast = Vue.toast
  }
}
